import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import questionImage from 'assets/images/question.svg';

import { Button } from 'components/buttons';
import { Buttons, Content, Image, Message, Title } from 'components/modal/styles';

import LABELS from './keys';

export const TitanModalMessage = () => {
  const { t } = useTranslation();

  return (
    <Content>
      <Image src={questionImage} />
      <Title>{t(LABELS.CONTENT_TITLE)}</Title>
      <Message>
        <Trans i18nKey={LABELS.CONTENT_MESSAGE[1]} components={{ br: <br /> }} />
      </Message>
    </Content>
  );
};

interface TitanModalButtonsProps {
  onAccept: () => void;
  onDecline: () => void;
}

export const TitanModalButtons = ({ onAccept, onDecline }: TitanModalButtonsProps) => {
  const { t } = useTranslation();

  return (
    <Buttons>
      <Button secondary onClick={onDecline}>
        {t(LABELS.NO)}
      </Button>
      <Button primary onClick={onAccept}>
        {t(LABELS.YES)}
      </Button>
    </Buttons>
  );
};
